export const FETCH_CANDIDATE_PROFILE = 'candidateExperience/views/interviewRequestDetails/FETCH_CANDIDATE_PROFILE'
export const FETCH_CANDIDATE_PROFILE_SUCCESS = 'candidateExperience/views/interviewRequestDetails/FETCH_CANDIDATE_PROFILE_SUCCESS'
export const FETCH_CANDIDATE_PROFILE_ERROR = 'candidateExperience/views/interviewRequestDetails/FETCH_CANDIDATE_PROFILE_ERROR'

export const FETCH_TALENT_ADVISOR = 'candidateExperience/views/interviewRequestDetails/FETCH_TALENT_ADVISOR'
export const FETCH_TALENT_ADVISOR_SUCCESS = 'candidateExperience/views/interviewRequestDetails/FETCH_TALENT_ADVISOR_SUCCESS'
export const FETCH_TALENT_ADVISOR_ERROR = 'candidateExperience/views/interviewRequestDetails/FETCH_TALENT_ADVISOR_ERROR'

export const fetchCandidateProfile = id => ({
  type: FETCH_CANDIDATE_PROFILE,
  meta: { id },
  payload: {
    fetchingCandidateProfile: true,
    fetchCandidateProfileError: null,
  },
})

export const fetchCandidateProfileSuccess = result => ({
  type: FETCH_CANDIDATE_PROFILE_SUCCESS,
  payload: {
    fetchingCandidateProfile: false,
    lastUpdatedCandidateProfile: Date.now(),
    candidateProfile: result.id,
  },
})

export const fetchCandidateProfileError = errorMessage => ({
  type: FETCH_CANDIDATE_PROFILE_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const fetchTalentAdvisor = id => ({
  type: FETCH_TALENT_ADVISOR,
  meta: { id },
  payload: {
    fetchingTalentAdvisor: true,
    fetchTalentAdvisorError: null,
  },
})

export const fetchTalentAdvisorSuccess = result => ({
  type: FETCH_TALENT_ADVISOR_SUCCESS,
  payload: {
    fetchingTalentAdvisor: false,
    lastUpdatedTalentAdvisor: Date.now(),
    talentAdvisor: result.id,
  },
})

export const fetchTalentAdvisorError = errorMessage => ({
  type: FETCH_TALENT_ADVISOR_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

const defaultView = {
  candidateProfile: null,
  fetchingCandidateProfile: false,
  fetchCandidateProfileError: null,
  lastUpdatedCandidateProfile: null,

  talentAdvisor: null,
  fetchingTalentAdvisor: false,
  fetchTalentAdvisorError: null,
  lastUpdatedTalentAdvisor: null,
}

const view = (state = defaultView, { type, payload }) => {
  switch (type) {
    case FETCH_CANDIDATE_PROFILE:
    case FETCH_CANDIDATE_PROFILE_SUCCESS:
    case FETCH_TALENT_ADVISOR:
    case FETCH_TALENT_ADVISOR_SUCCESS:
      return { ...state, ...payload }

    case FETCH_CANDIDATE_PROFILE_ERROR:
      return {
        ...state,
        fetchingCandidateProfile: false,
        fetchCandidateProfileError: payload,
      }

    case FETCH_TALENT_ADVISOR_ERROR:
      return {
        ...state,
        fetchingTalentAdvisor: false,
        fetchTalentAdvisorError: payload,
      }

    default:
      return state
  }
}

export default view

export const getInterviewRequestDetailsView = state => state.views.interviewRequests.interviewRequestDetails || defaultView
